import React, { useEffect, useState, useCallback, Suspense, lazy } from "react";
import NeedCategories from "./NeedCategories";
import { Row, Form, Col, FormGroup, Label, Input, Button } from "reactstrap";
import NeedPhotos from "./NeedPhotos";
import { useDispatch, useSelector } from "react-redux";
import { fetchGurdwaras } from "../../../components/Header/Data";
import CustmorAvailability from "./CustmorAvailability";
import { GetQuestionsById } from "../../../components/Header/Data2";
import NeedQuestions from "./NeedQuestions";
import NewlyEngagedForm from "../settingsComponents/NewlyEngagedForm";
import WhomToNotify from "./WhomToNotify";
import AsyncSelect from "react-select/async";
import {
  setAlternativePhoneOne,
  setAlternativePhoneTwo,
  setCityName,
  setDialExtension,
  setNeedRadius,
  setPhone,
  setTerms,
  setTimeZone,
  setTitle,
  setZipcode,
} from "../../../redux/slices/RequestFormSlice";
const NeedDescription = lazy(() => import("./NeedDescription"));

const UpcomingEvent = ({
  categories,
  subCategories1,
  subCategories,
  setSubCategories,
  editMode,
  handleFormSubmit,
  selectedCat,
  setSelectedCat,
  isLoading,
}) => {
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const [gurdwaras, setGurdwaras] = useState([]);
  const formData = useSelector((state) => state.requestForm);
  const dispatch = useDispatch();
  const isAdmin = user && user.Role === "admin";
  const [allCities, setAllCities] = useState([]);
  const [questions, setQuestions] = useState([]);

  const fetchData = async () => {
    const gurudwaras = await fetchGurdwaras();
    setGurdwaras(gurudwaras);
  };

  useEffect(() => {
    const fetchQuestions = async () => {
      if (selectedCat) {
        const quest = await GetQuestionsById(selectedCat);
        console.log(quest);
        setQuestions(quest);
      }
    };
    fetchQuestions();
  }, [selectedCat]);

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const response = await fetch(
          "https://countriesnow.space/api/v0.1/countries",
          {
            method: "GET",
            headers: { "Content-Type": "application/json" },
          }
        );
        const data = await response.json();
        if (data.error) throw new Error(data.msg);
        const cities = data.data.flatMap((country) => country.cities);
        console.log("Fetched cities count:", cities.length);
        setAllCities(cities);
      } catch (error) {
        console.error("Error fetching cities:", error);
        setAllCities([]);
      }
    };
    fetchCities();
    fetchData();
  }, []);

  const loadOptions = useCallback(
    (inputValue, callback) => {
      // Only return options if input is 3 or more characters
      if (inputValue.length < 3) {
        console.log("Input too short:", inputValue);
        callback([]);
        return;
      }

      // Simulate async filtering (in reality, this could hit an API)
      setTimeout(() => {
        const filteredCities = allCities
          .filter((city) =>
            city.toLowerCase().includes(inputValue.toLowerCase())
          )
          .slice(0, 50) // Limit to 50 results for performance
          .map((city) => ({ label: city, value: city }));
        console.log(
          "Filtered cities for input:",
          inputValue,
          filteredCities.length
        );
        callback(filteredCities);
      }, 300); // Small delay to mimic API call
    },
    [allCities]
  );

  const CityNames = () => {
    return (
      <FormGroup>
        <Label>
          City Name <b className="text-danger">*</b>
        </Label>
        <AsyncSelect
          cacheOptions
          defaultOptions={[]} // No default options to prevent showing until 3 letters
          loadOptions={loadOptions}
          value={
            formData?.cityName
              ? { label: formData.cityName, value: formData.cityName }
              : null
          }
          onChange={(selectedOption) => {
            const selectedCity = selectedOption ? selectedOption.value : "";
            console.log("City selected:", selectedCity);
            dispatch(setCityName(selectedCity));
          }}
          placeholder="Type at least 3 letters to search cities..."
          noOptionsMessage={() =>
            formData?.cityName?.length < 3
              ? "Type at least 3 letters"
              : "No cities found"
          }
          isClearable
          onMenuOpen={() => console.log("Menu opened")}
          onMenuClose={() => console.log("Menu closed")}
        />
      </FormGroup>
    );
  };

  return (
    <Form>
      <Col className="request-form p-4 mt-3">
        <p className="text-center">Upcoming Wedding/Event</p>
        <NeedCategories
          categories={categories}
          subCategories1={subCategories1}
          subCategories={subCategories}
          setSubCategories={setSubCategories}
          setSelectedCat={setSelectedCat}
        />
        <Row>
          <Col>
            <FormGroup>
              <Label>
                Enter Ad Title <b className="text-danger">*</b>
              </Label>
              <Input
                type="text"
                name="Title"
                placeholder="Ex: Seeking an event Decorator great with Flowers"
                value={formData.Title}
                onChange={(e) => dispatch(setTitle(e.target.value))}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <CustmorAvailability />
        </Row>
        <Row>
          <div style={{ marginTop: "-3%", marginBottom: "2%" }}>
            <NewlyEngagedForm userDetails={formData} />
          </div>
        </Row>

        <Suspense fallback={<div>Loading description...</div>}>
          <NeedDescription />
        </Suspense>
        <Row>
          <Col sm={12} lg={isAdmin ? 2 : 4}>
            <FormGroup>
              <Label>
                Enter Zip code
                <b className="text-danger">*</b>
              </Label>
              <Input
                type="text"
                name="Zipcode"
                placeholder="Enter Zip code where Service Vendor should arrive"
                onChange={(e) => {
                  const { value } = e.target;
                  const isValidZipCode = /^\d{0,5}$/.test(value);
                  if (isValidZipCode) {
                    dispatch(setZipcode(value));
                  }
                }}
                value={formData.Zipcode}
              />
            </FormGroup>
          </Col>
          <Col sm={12} lg={4}>
            <CityNames />
          </Col>
          <Col sm={12} lg={4}>
            <FormGroup>
              <Label>
                Timezone <b className="text-danger">*</b>
              </Label>
              <Input
                type="select"
                name="TimeZone"
                value={formData?.timeZone}
                onChange={(e) => dispatch(setTimeZone(e.target.value))}
              >
                <option value="America/New_York, Eastern Time">
                  America/New_York (Eastern Time)
                </option>
                <option value="America/Chicago, Central Time">
                  America/Chicago (Central Time)
                </option>
                <option value="America/Denver, Mountain Time">
                  America/Denver (Mountain Time)
                </option>
                <option value="America/Los_Angeles, Pacific Time">
                  America/Los_Angeles (Pacific Time)
                </option>
                <option value="UTC, Coordinated Universal Time">
                  UTC (Coordinated Universal Time)
                </option>
                <option value="Europe/London, GMT">Europe/London (GMT)</option>
                <option value="Europe/Berlin, Central European Time">
                  Europe/Berlin (Central European Time)
                </option>
              </Input>
            </FormGroup>
          </Col>
          {isAdmin && (
            <Col sm={12} lg={2}>
              <FormGroup>
                <Label>
                  Radius <b className="text-danger">*</b>
                </Label>
                <Input
                  type="select"
                  name="radius"
                  value={formData.needRadius}
                  onChange={(e) => dispatch(setNeedRadius(e.target.value))}
                >
                  <option value="">Select radius</option>
                  <option value="10">10 miles</option>
                  <option value="20">20 miles</option>
                  <option value="30">30 miles</option>
                  <option value="50">50 miles</option>
                  <option value="100">100 miles</option>
                </Input>
              </FormGroup>
            </Col>
          )}
        </Row>
        <Row>
          <Col sm={12} lg={isAdmin ? 3 : 4} className="phone">
            <FormGroup>
              <Label>
                Mobile Number <b className="text-danger">*</b>
              </Label>
              <Input
                type="number"
                name="Phone"
                value={formData.Phone}
                onChange={(e) => {
                  const { value } = e.target;
                  const isValidPhone = /^\d{0,10}$/.test(value);
                  if (isValidPhone) {
                    dispatch(setPhone(value));
                  }
                }}
              />
            </FormGroup>
          </Col>
          <Col sm={12} lg={isAdmin ? 3 : 4} className="alterPhone-1">
            <FormGroup>
              <Label>
                Mobile Number (family member) <b className="text-danger">*</b>
              </Label>
              <Input
                type="number"
                name="alternativePhoneOne"
                placeholder="This improves call answers"
                value={formData.alternativePhoneOne}
                onChange={(e) => {
                  const { value } = e.target;
                  const isValidPhone = /^\d{0,10}$/.test(value);
                  if (isValidPhone) {
                    dispatch(setAlternativePhoneOne(value));
                  }
                }}
              />
            </FormGroup>
          </Col>
          <Col sm={12} lg={isAdmin ? 3 : 4} className="alterPhone-2">
            <FormGroup>
              <Label>Mobile Number (family member)</Label>
              <Input
                type="number"
                name="alternativePhoneTwo"
                placeholder="This improves call answers"
                value={formData.alternativePhoneTwo}
                onChange={(e) => {
                  const { value } = e.target;
                  const isValidPhone = /^\d{0,10}$/.test(value);
                  if (isValidPhone) {
                    dispatch(setAlternativePhoneTwo(value));
                  }
                }}
              />
            </FormGroup>
          </Col>
          {isAdmin && (
            <Col sm={12} lg={3} className="diel-ext">
              <FormGroup>
                <Label>
                  Dial Extension <b className="text-danger">*</b>
                </Label>
                <Input
                  placeholder="Dial Extension"
                  type="text"
                  name="dialExtension"
                  value={formData.dialExtension}
                  onChange={(e) => {
                    const { value } = e.target;
                    const isValid = /^\d{0,5}$/.test(value);
                    if (isValid) {
                      dispatch(setDialExtension(value));
                    }
                  }}
                  disabled={user?.RoleId === 1 ? false : true}
                />
              </FormGroup>
            </Col>
          )}
        </Row>
        <NeedPhotos />
      </Col>
      <Col className="request-form p-4 mt-5">
        <NeedQuestions catQuestions={questions} editMode={editMode} />
      </Col>
      {isAdmin && (
        <Col className="request-form p-4 mt-3">
          <h5 className="pb-3">Whom To Be Notified</h5>
          <WhomToNotify />
        </Col>
      )}
      <Col className="request-form p-4 mt-3">
        <h5 className="pb-3">Terms</h5>
        <h6 className="fst-italic pb-3 small">
          You'll receive email & text message responses from Event vendors
          willing to serve your upcoming event.
        </h6>
        <div className="mb-3 form-check">
          <FormGroup>
            <Input
              type="checkbox"
              name="Terms"
              checked={formData.Terms === 1}
              onChange={(e) => {
                dispatch(setTerms(e.target.checked ? 1 : 0));
              }}
              className="form-check-input"
              id="exampleCheck1"
            />
            <Label className="form-check-label ps-2" htmlFor="exampleCheck1">
              I understand and Accept Terms
            </Label>
          </FormGroup>
        </div>
      </Col>
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "flex-end",
          padding: "10px",
        }}
      >
        <Button
          type="submit"
          className="btn btn-danger"
          disabled={isLoading}
          onClick={handleFormSubmit}
        >
          {Object.keys(editMode).length > 0
            ? "Update Request"
            : "Submit Request"}
        </Button>
      </div>
    </Form>
  );
};

export default UpcomingEvent;
